var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M740 5113 c-201 -34 -381 -193 -443 -388 l-22 -70 0 -1775 0 -1775 26 -71 c33 -90 88 -173 153 -230 44 -39 1100 -659 1268 -745 71 -36 164 -59 240 -59 183 0 385 112 477 265 65 108 75 150 81 360 l5 190 465 5 c449 5 467 6 523 27 188 71 321 225 362 418 18 85 22 716 5 777 -22 79 -91 131 -175 131 -80 0 -138 -40 -170 -115 -12 -31 -15 -94 -15 -380 0 -311 -2 -347 -19 -383 -22 -50 -69 -91 -119 -105 -23 -6 -197 -10 -449 -10 l-413 0 0 1268 c0 1393 3 1317 -61 1445 -20 39 -58 88 -103 132 -65 64 -119 97 -636 395 l-566 325 1115 3 1116 2 44 -27 c28 -18 53 -44 68 -72 23 -44 23 -45 23 -435 0 -358 2 -394 19 -431 57 -126 217 -149 305 -45 45 54 48 84 44 519 -3 394 -4 408 -26 471 -32 89 -66 145 -130 212 -65 69 -130 112 -220 147 l-67 26 -1340 1 c-737 1 -1351 0 -1365 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4110 3661 c-89 -28 -140 -92 -140 -175 0 -72 19 -102 139 -221 l111 -110 -709 -5 -709 -5 -39 -31 c-49 -40 -73 -87 -73 -148 0 -66 37 -128 93 -159 l42 -22 693 -5 692 -5 -101 -100 c-55 -55 -109 -117 -120 -137 -21 -41 -25 -111 -8 -155 23 -61 100 -113 169 -113 70 0 108 31 397 321 234 236 283 291 292 324 14 50 14 60 0 110 -9 33 -58 87 -283 313 -149 151 -289 284 -311 297 -46 27 -99 37 -135 26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.57e04d74ea852478dfc3f59d0e63ee02.svg";
export { ForwardRef as ReactComponent };